import React from 'react';
import { Tooltip } from 'antd';
import RecurringIcon from "../../../../../../assets/icons/recurring.svg";
import GaIcon from "../../../../../../assets/icons/grant-agreement.svg";
import { UnderlyingContent, TableLabel } from '../../styles';
import { formatAmount } from "../../../../../../utils/commonUtil";

const columns = (grantDetailsHandler) => [
  {
    title: "",
    dataIndex: "",
    key: "recurringGrant",
    render: (value, record) => {
      if (record.isRecurring) {
        return (
          <Tooltip placement="bottomLeft" title="Recurring Grant Schedule">
            <img className="pointer" src={RecurringIcon} alt="RecurringIcon" />
          </Tooltip>
        );
      } else if (record.grantAgreement) {
        return (
          <Tooltip placement="bottomLeft" title="Grant Agreement">
            <img className="pointer" src={GaIcon} alt="GaIcon" />
          </Tooltip>
        );
      }
    }
  }, {
    title: 'Transaction ID',
    dataIndex: 'transactionId',
    key: 'transactionId',
    render: value => (<UnderlyingContent onClick={() => grantDetailsHandler(value, "single")}>{value}</UnderlyingContent>),
  }, {
    title: 'Entered Date',
    dataIndex: 'receiveDate',
    key: 'receiveDate',
    render: value => (<TableLabel>{value}</TableLabel>),
  }, {
    title: 'Amount',
    dataIndex: 'grantAmount',
    key: 'grantAmount',
    render: value => (<TableLabel>{formatAmount(value)}</TableLabel>),
  }, {
    title: 'Purpose',
    dataIndex: 'grantPurpose',
    key: 'grantPurpose',
    render: value => (<TableLabel>{value}</TableLabel>),
  }, {
    title: 'Recognition',
    dataIndex: 'grantRecognition',
    key: 'grantRecognition',
    render: value => (<TableLabel>{value}</TableLabel>),
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: value => (<TableLabel>{value}</TableLabel>),
  }
];

export default columns;
